// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import React from 'react';
import classnames from 'classnames';

export interface TopAppbarFixedAdjustProps {
  tag?: string;
  className?: string;
  dense?: boolean;
  prominent?: boolean;
  short?: boolean;
}

const FixedAdjust: React.FunctionComponent<TopAppbarFixedAdjustProps> = ({
  tag: Tag = 'main',
  children,
  className = '',
  dense = false,
  prominent = false,
  short = false,
  ...otherProps
}) => {
  const base = 'mdc-top-app-bar';
  const suffix = '-fixed-adjust';
  const classes = classnames(className, {
    [base + '--short' + suffix]: short,
    [base + '--dense' + suffix]: dense && !prominent,
    [base + '--dense-prominent' + suffix]: dense && prominent,
    [base + '--prominent' + suffix]: !dense && prominent,
    [base + '-' + suffix]: !short && !dense && !prominent,
  });

  return (
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/26635
    // @ts-ignore
    <Tag className={classes} {...otherProps}>
      {children}
    </Tag>
  );
};

export default FixedAdjust;



// WEBPACK FOOTER //
// ./packages/top-app-bar/FixedAdjust.tsx